import { Alert, Snackbar } from '@mui/material';

export default function Notification(props) {
   const { open, onClose, message, delay, severity } = props;

   return (
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={open} autoHideDuration={delay} onClose={onClose}>
         <Alert onClose={onClose} severity={severity} variant="filled" sx={{ width: '100%' }}>
            <span dangerouslySetInnerHTML={{ __html: message }} />
         </Alert>
      </Snackbar>
   )
}